import { useNavigate } from 'react-router-dom';

import { Button } from 'components';

const LoginButtonArea = () => {
  const nav = useNavigate();

  function onClickEmailButton() {
    nav('/login');
  }

  function onClickSignUpButton() {
    nav('/sign-up');
  }

  return (
    <div className=" flex w-full flex-col gap-2">
      <Button
        className="h-8 w-full items-center justify-center"
        text="Sign Up"
        type="blue"
        onClick={onClickSignUpButton}
      />
      <Button
        className="h-8 w-full items-center justify-center"
        text="LogIn"
        type="secondary"
        onClick={onClickEmailButton}
      />
    </div>
  );
};

export default LoginButtonArea;
